<template>
  <div class="cropper">
    <v-modal modalName="cropper-modal" class="cropper__container">
      <template slot="header">
        <div class="cropper__container__header">
          <span class="cropper__container__header--title">Crop image</span>
          <v-btn text large fab @click="close" class="cropper__container__header--close">
            <font-awesome-icon icon="times" />
          </v-btn>
        </div>
      </template>
      <template slot="body">
        <div class="cropper__container__body">
          <div class="cropper__container__body__area">
            <vue-cropper ref="cropper" :aspect-ratio="aspectRatio" :src="offerImg" alt=" " />
          </div>
          <v-btn
            v-show="offerImg"
            text
            class="cropper__container__body__btn"
            @click.prevent="zoom(0.2)"
          >
            <font-awesome-icon icon="search-plus" />
          </v-btn>
          <v-btn
            v-show="offerImg"
            text
            class="cropper__container__body__btn"
            @click.prevent="zoom(-0.2)"
          >
            <font-awesome-icon icon="search-minus" />
          </v-btn>
          <v-btn
            v-show="offerImg"
            text
            class="cropper__container__body__btn"
            @click.prevent="rotate(90)"
          >+90deg</v-btn>
          <v-btn
            v-show="offerImg"
            text
            class="cropper__container__body__btn"
            @click.prevent="rotate(-90)"
          >-90deg</v-btn>
          <v-btn
            v-show="offerImg"
            text
            class="cropper__container__body__btn"
            @click.prevent="reset"
          >
            <font-awesome-icon icon="undo" />
          </v-btn>
        </div>
      </template>
      <template slot="footer">
        <div class="cropper__container__footer">
          <v-btn v-show="offerImg" text class="cropper__container__body__save" @click="save">
            <font-awesome-icon icon="check" />
          </v-btn>
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import VModal from "@/components/VModal";
import "cropperjs/dist/cropper.css";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    uploadImg: Function,
    aspectRatio: Number,
    data: Object
  },

  components: {
    VueCropper,
    VModal
  },

  data() {
    return {
      modalName: "imageCropper",
      offerImg: "",
      changeImg: ""
    };
  },
  methods: {
    ...mapActions({
      croppedImg: "cropper/afterCrop",
      toggleCropperModal: "ui/cropperModalState"
    }),

    close() {
      this.toggleCropperModal();
    },

    save() {
      this.saveImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg", 0.5);
      this.croppedImg(this.saveImg);
      this.close();
    },

    change() {
      this.changeImg = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg", 0.5);
      this.close();
    },

    reset() {
      this.$refs.cropper.reset();
    },

    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },

    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },

    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    }
  },

  computed: {
    ...mapState({
      cropper: state => state.cropper
    })
  },

  mounted() {
    const file = this.cropper.beforeCrop.target.files[0];
    if (file.type.indexOf("image/") === -1) {
      alert("Please select an image file");
      return;
    }
    if (typeof FileReader === "function") {
      const reader = new FileReader();
      reader.onload = event => {
        var img = document.createElement("img");
        img.src = event.target.result;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var MAX_WIDTH = 500;
        var MAX_HEIGHT = 500;
        var width = img.width;
        var height = img.height;

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        this.offerImg = img.src;
        this.$refs.cropper.replace(img.src);
      };

      reader.readAsDataURL(file);
    } else {
      alert("Sorry, FileReader API not supported");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import @/styles/variables.sass
@import @/styles/mixins.sass
@import @/styles/base.sass

.cropper
  position: fixed
  width: 100%
  height: 100%
  left: 0
  top: 0
  display: flex
  flex-flow: column
  justify-content: center
  backdrop-filter: blur(8px)
  z-index: 10

  &__container
    width: 600px
    height: 500px
    border-radius: 15px
    box-shadow: -2px -1px 5px rgba(0, 0, 0, .3)

    @include for-size(phone-only)
      transform: scale(.8)

    &__header
      &--title
        position: relative
        left: 240px

      &--close
        position: relative
        top: -20px
        left: 420px

    &__body
      height: 250px
      margin-bottom: 80px

      &--icon
        margin: 20px auto
        width: 50px

      &__area
        margin: 50px 0 
        transform: scale(1.5)

    &__footer
      position: relative
      display: flex
      justify-content: center

    .check
      padding: 0
      margin: 0

.large-icon
  width: 200px

input[type="file"]
  display: none

</style>
